import { useQuery } from "@tanstack/react-query";
import { downloadTransactionReport } from "../../service/query/auth";

export const useDownloadTransactionReport = ({
  payload,
  downloadFormat
}) => {
  const transactionReport = useQuery({
    queryKey: ["transactionReport", payload],
    queryFn: () => downloadTransactionReport({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  });

  return { ...transactionReport };
};
